import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
// Desired file extesion
const fileExtension = ".xlsx";

export const exportToSpreadsheet = (data, fileName) => {
    //Create a new Work Sheet using the data stored in an Array of Arrays.
    const workSheet = XLSX.utils.aoa_to_sheet(data);
    // Generate a Work Book containing the above sheet.
    const workBook = {
        Sheets: { data: workSheet, cols: [] },
        SheetNames: ["data"],
    };
    // Exporting the file with the desired name and extension.
    const excelBuffer = XLSX.write(workBook, { bookType: "xlsx", type: "array" });
    const fileData = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(fileData, fileName + fileExtension);
};

export const importFromSpreadsheet = (content) => {
    const workBook = XLSX.read(content, { type: "binary" });
    const workSheetName = workBook.SheetNames[0];
    const workSheet = workBook.Sheets[workSheetName];
    const data = XLSX.utils.sheet_to_json(workSheet);
    return data;
}

export const dataFromJson = (data) => {
    let headers = [];
    let rows = [];
    data.forEach((row) => {
        Object.keys(row).forEach((key) => {
            if (!headers.includes(key)) {
                headers.push(key);
            }
        });
        rows.push(Object.values(row));
    });
    return [headers, ...rows];
};